import { format } from "date-fns";
import { LuDownload } from "react-icons/lu";

import { Badge } from "@/components/ui/badge/badge";
import { cn } from "@/lib/utils";
import { useViewModal } from "./use-view-modal";
import { Button } from "@/components/ui/button/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

const classes: {
  [key: string]: string;
} = {
  Approved: `bg-blue-600 text-white font-normal`,
  Pending: `bg-yellow-500 text-black font-normal`,
  Rejected: `bg-red-500 text-white font-normal`,
  Cancelled: `bg-indigo text-white font-normal`,
};

export const ViewRepaymentRequestModal = () => {
  const { open, onOpenChange, repaymentRequest } = useViewModal();

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle className="tracking-normal">
              Loan Repayment Request by {repaymentRequest?.employeeName}
            </DialogTitle>
          </DialogHeader>

          <div className="mt-5">
            <div className="flex flex-row items-center gap-2">
              <Badge
                className={cn(classes[repaymentRequest?.status as string])}
              >
                {repaymentRequest?.status}
              </Badge>
              <span>•</span>
              {repaymentRequest?.createdAt && (
                <div className="flex flex-row items-center text-sm">
                  {format(
                    new Date(repaymentRequest?.createdAt as string),
                    "PPP"
                  )}
                </div>
              )}
              <span>•</span>
              <div className="flex flex-row items-center text-sm">
                <span>{repaymentRequest?.employeeName}</span>
              </div>
            </div>

            <div className="flex flex-row items-center text-base gap-1 mt-4">
              <span>Amount Paid :</span>
              <span className="font-medium">{repaymentRequest?.amount}</span>
            </div>

            <div className="flex mt-3">
              <Button
                size="sm"
                variant="outline"
                className="flex items-center gap-1 font-normal"
                asChild
              >
                <a
                  href={repaymentRequest?.attachment}
                  download="Download Attachment"
                  target="_blank"
                  rel="noreferrer"
                >
                  <LuDownload /> Attachment
                </a>
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
